import { alpha } from '@material-ui/core/styles';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { NoahFont, colors, fontWeight } from '../../../assets';

export const useStyles = makeStyles(theme =>
  createStyles({
    datePicker: {
      textAlign: 'center',
      backgroundColor: 'transparent',
      border: '0px',

      '& .react-datepicker__header': {
        textAlign: 'center',
        backgroundColor: 'transparent',
        borderBottom: '0px',
        paddingTop: '0px',
      },

      '& .react-datepicker__week': {
        margin: '2px 0',
      },

      '& .react-datepicker__day': {
        width: '36px',
        height: '36px',
        lineHeight: '36px',
        borderRadius: '18px',
        fontFamily: NoahFont,
        fontSize: '14px',
        fontWeight: fontWeight.bold,
        margin: '0 2px',
        outline: 'none',

        '&.react-datepicker__day--today:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range)': {
          color: colors.secondary.main,
        },

        '&.react-datepicker__day--in-range, &.react-datepicker__day--in-selecting-range': {
          borderRadius: 0,
          padding: '0 2px',
          margin: 0,
          boxSizing: 'content-box',
        },

        '&.react-datepicker__day--range-start, &.react-datepicker__day--selecting-range-start': {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderTopLeftRadius: '18px',
          borderBottomLeftRadius: '18px',
        },

        '&.react-datepicker__day--range-end, &.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selecting-range-start):hover':
          {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderTopRightRadius: '18px',
            borderBottomRightRadius: '18px',
          },

        '&.react-datepicker__day--range-start.react-datepicker__day--range-end,  &.react-datepicker__day--selecting-range-start:hover':
          {
            borderRadius: '18px',
          },
      },

      '& .react-datepicker__day--outside-month': {
        color: colors.grey80,
      },

      '& .react-datepicker__day-name': {
        width: '36px',
        fontFamily: NoahFont,
        fontSize: '10px',
        fontWeight: fontWeight.bold,
        textTransform: 'uppercase',
        color: colors.secondary.main,
        margin: '0px 2px',
      },

      '& .react-datepicker__day--selected, .react-datepicker__day--in-range': {
        backgroundColor: colors.secondary.main,
      },

      '& .react-datepicker__month': {
        margin: '4px 0px 0px',
      },

      '& .react-datepicker__month-text--keyboard-selected, .react-datepicker__month--selected': {
        backgroundColor: colors.primary.main,

        '&:hover': {
          backgroundColor: colors.primary.main,
        },
      },

      '& .react-datepicker__month-text.react-datepicker__month--selected:hover': {
        backgroundColor: colors.primary.main,
      },

      '& .react-datepicker__month .react-datepicker__month-text': {
        margin: '16px',
        fontSize: '16px',
        width: '75px',

        [theme.breakpoints.down('xs')]: {
          margin: '16px 8px',
          fontSize: '14px',
          width: '68px',

          // TODO: remove this commented line, added just to start deploy
        },
      },

      '& .react-datepicker__month-text--selected, & .react-datepicker__month-text--keyboard-selected': {
        backgroundColor: `${colors.primary.main} !important`,

        '&:hover': {
          backgroundColor: `${colors.primary.main} !important`,
        },
      },

      '& .react-datepicker__month-text.react-datepicker__month--selected': {
        backgroundColor: `${colors.primary.main} !important`,

        '&:hover': {
          backgroundColor: `${colors.primary.main} !important`,
        },
      },

      '& .react-datepicker__month-text--today': {
        fontWeight: 'normal',
      },

      '& .react-datepicker__day--in-selecting-range': {
        backgroundColor: alpha(colors.secondary.main, 0.8),
      },
    },
  }),
);
